<template>
	<div>
		<router-link class="news__link col-12 col-lg-6 text-decoration-none" :to="language == 'hu' ? '/hirek/'+id+'/'+linkHU : '/news/'+id+'/'+linkEN" v-on:click.native="sendData(id)" v-if="!loader">
			<div class="row py-2 g-2">
				<div class="d-flex flex-wrap">
					<div class="col-md-4 col-12 p-0">
						<div class="bg-dark news__img" v-bind:style="{ 'background-image': 'url(' + new_images[0] + ')' }"></div>
					</div>
					<div class="col-md-8 col-12 p-0 bg-gradient-brown">
						<div class="text-white p-3 h-100">
							<h4 class="news__title" v-text="language == 'hu' ? titleHU : titleEN"></h4>
							<p class="news__text" v-html="language == 'hu' ? introHU : introEN"></p>
						</div>
					</div>
				</div>
			</div>
		</router-link>
	</div>
</template>
<script>
	import { Bus }  from "../bus.js";
	import firebase from "firebase/app";
	
	export default {
		data: function () {
			return {
				loader: true,
				language: this.lang,
				original_images: this.img,
				new_images: []
			};
		},
		props: ["id", "linkHU", "linkEN", "titleHU", "titleEN", "introEN", "introHU", "img", "lang"],
		created: function(){
			this.setImg(this.original_images);
			this.loader = false;
		},
		mounted: function(){
			var self = this;
	    	Bus.$on("lang", (lang) => {
				if(lang === "hu"){
					self.language = "hu";
				}else{
					self.language = "en";
				}
			});
		},
		methods:{
			sendData: function(index){
				Bus.$emit("current", index);
			},
			setImg: function(array){
				
				var self = this;
				for (var i = 0; i < array.length; i++) {
					console.log(array[i]);
					firebase.storage().ref('img/'+array[i]).getDownloadURL().then(function(url) {
						self.new_images.push(url);
						console.log(url);
					});
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/News_item.vue